<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading && items.length" class="position-relative items">
        <v-container class="pa-md-4">
          <v-sheet
            class="d-flex align-center justify-center pb-6 pb-sm-8 pb-md-10"
            color="transparent"
            height="100%"
          >
            <div class="primary--text text-h4 text-lg-h3 font-weight-bold">
              Serviços
            </div>
          </v-sheet>
          <v-row class="ma-md-n4" justify="center">
            <template v-for="(item, keyItems) in items">
              <v-col :key="keyItems" class="pa-md-4" cols="12" sm="6" md="3">
                <ServiceCard v-bind="item" />
              </v-col>
            </template>
          </v-row>
        </v-container>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import ServiceCard from "../cards/ServiceCard.vue";

const _config = {
  mod: "services",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  components: {
    LoadingWidget,
    ServiceCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  padding-bottom: 120px;
  padding-top: 80px;

  @media screen and (max-width: 960px) {
    padding-bottom: 80px;
    padding-top: 60px;
  }

  @media screen and (max-width: 600px) {
    padding-bottom: 60px;
    padding-top: 40px;
  }

  &:before {
    background-image: url(../../assets/img/bg/services.png);
    background-position: left 7vw top -50px;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0.1;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
